import { Fade, Grid, InputAdornment } from "@material-ui/core";
import React from "react";
import TextFieldWrapper from "../../components/TextField";
import { Visibility } from "@material-ui/icons";
import { connect } from "react-redux";

const RegisterStage1 = ({ Register_Mobile_Email, registerStageNumber }) => {
  const [showPass, setShowPass] = React.useState(true);

  return (
    <>
      <Fade in={registerStageNumber === 1} timeout={500}>
        <Grid
          item
          container
          justifyContent="center"
          spacing={2}
          xl={6}
          lg={6}
          md={9}
          xs={10}
          style={{ margin: "auto" }}
        >
          <Grid item xs={12}>
            <TextFieldWrapper
              name="cellphone"
              label="شماره موبایل"
              InputProps={{
                readOnly: isNaN(Register_Mobile_Email) ? false : true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper
              name="email"
              label="ایمیل"
              InputProps={{
                readOnly: isNaN(Register_Mobile_Email) ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper name="first_name" label="نام" />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper name="last_name" label="نام خانوادگی" />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper name="ssn" label="کد ملی" />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper
              name="password"
              label="رمز عبور"
              type={showPass ? "password" : "text"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <Visibility
                      color="primary"
                      fontSize="small"
                      onClick={() => setShowPass(!showPass)}
                      style={{ cursor: "pointer" }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper
              name="confirm_password"
              label="تکرار رمز عبور"
              type={showPass ? "password" : "text"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <Visibility
                      color="primary"
                      fontSize="small"
                      onClick={() => setShowPass(!showPass)}
                      style={{ cursor: "pointer" }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Fade>
    </>
  );
};

const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { Register_Mobile_Email, registerStageNumber } = loginReducer;

  return { Register_Mobile_Email, registerStageNumber };
};

export default connect(mapStateToProps)(RegisterStage1);
